export default "__VITE_ASSET__$0IkdYyA__"